import React, { Component } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Tabs from "@material-ui/core/Tabs";
import ReportIcon from '@material-ui/icons/Report';
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import SendIcon from "@material-ui/icons/Send";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CancelIcon from '@material-ui/icons/Cancel';
import AttachmentIcon from '@material-ui/icons/Attachment';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { setPeerToPeerChatRoom } from "../../api/helper";
import { auth } from "../../service/firebase";
import { db, storageRef } from "../../service/firebase";
import { setChatType, setcomponentbgcolor } from "../../redux/actions/appActions";
import Services from "../../api/api";
import swal from "sweetalert";
import parse from 'html-react-parser';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import HomeIcon from "@material-ui/icons/Home";
import * as _ from "lodash";
import moment from 'moment';
import { scriptCheck } from "../../api/helper";
import { logError } from "../../helpers/auth";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

class ChatWindow extends Component {
  constructor(props) {
    super();
    this.state = {
      value: 0,
      applicantObj: {},
      user: auth().currentUser,
      chats: [],
      content: "",
      readError: null,
      writeError: null,
      loadingChats: false,
      authenticated: false,
      topic: '',
      progress: 0,
      isButtonDisabled: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.deleteChat = this.deleteChat.bind(this);
    this.switchToPeerChat = this.switchToPeerChat.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.handleImageAsFile = this.handleImageAsFile.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.handleImgModalOpen = this.handleImgModalOpen.bind(this);
    this.myRef = React.createRef();
    console.log("constructor state::", this.state)
  }

  // static getDeriveStateFromProps(props){
  //   let userObj = auth().currentUser;
  //   return {user: userObj}
  // }

  async componentDidMount() {
    try{
      console.log("componentDidMount chatwindow>>>", this.props, this.state.user, this);
      if (this.props.location.state && this.props.location.state.applicant) {
        // this.setChatArea(this.props.fbuserObj.uid, this.props.location.state.id);
        // console.log("setchatarea::", userObj.uid, this.props.location.state.applicant.id);
        this.setChatArea(this.props.location.state.userObj.uid, this.props.location.state.applicant.id);
      } else {
        //this.props.history.goBack();
        this.props.history.push("/layout/peerchat");
        console.error('this.props.location.state>', this.props.location.state);
      }
      this.initKeyboard();
    }catch(err){
      console.log(err)
      var errorObj = {
        component: 'ChatWindow',
        method: 'componentDidMount',
        error: err
      }
      logError(errorObj);
    }
  }

  componentWillUnmount() {
    this.setState({
      chats: []
    })
    // this.props.setChatType('group');
  }

  initKeyboard() {
    var self = this;
    if (window.cordova) {
      document.addEventListener('deviceready', function () {
        window.addEventListener('keyboardDidShow', function () {
          console.log("keyboard shown");
          self.scrollToBottom('chatBox');
        });
      })
    }
  }

  scrollToBottom(id) {
    setTimeout(function () {
      try {
        var element = document.getElementById('chatBox');
        console.log("element.scrollHeight - element.clientHeight", element.scrollHeight, element.clientHeight);
        element.scrollTop = element.scrollHeight - element.clientHeight;
      } catch (err) {
        console.log("err::", err);
      }
    }, 500);
  }

  setChatRoom(senderId, receiptId) {
    let { communityuid, chatConfig, location } = { ...this.props };
    let chatroom = `${communityuid}`;
    if (location.state.chatType == "peer" || location.state.chatType == "admin") {
      return (chatroom = `${chatroom}/${location.state.chatType
        }/${setPeerToPeerChatRoom(senderId, receiptId)}`);
    } else {
      this.setState({ topic: `${chatroom}-${location.state.chatType}-${receiptId}` },
        () => {
          if (window.cordova) {
            // if(window.FCMPlugin){
            //   window.FCMPlugin.subscribeToTopic(this.state.topic);
            // }else if(window.cordova.plugins.firebase && window.cordova.plugins.firebase.messaging){
            //   window.cordova.plugins.firebase.messaging.subscribe(this.state.topic);
            // }else 
            if(window.FirebasePlugin){
              window.FirebasePlugin.subscribe(this.state.topic, function(){
                console.log("Subscribed to topic");
              }, function(error){
                  console.error("Error subscribing to topic: " + error);
              });
            }
          }
        });

      return (chatroom = `${chatroom}/${location.state.chatType}/${receiptId}`);
    }
  }

  setChatArea(senderId, receiptId) {
    let { location } = { ...this.props };
    this.setState({ readError: null, loadingChats: true });
    const chatArea = this.myRef.current;
    try {
      var sender = JSON.parse(localStorage.getItem("obj")).userId
      console.log(receiptId, senderId);
      let chatroom = this.setChatRoom(sender, receiptId);


      db.ref(chatroom).on("value", (snapshot) => {
        let chats = [];
        snapshot.forEach((snap) => {
          var chatNode = {};
          chatNode = snap.val();
          chatNode.key = snap.key;
          chats.push(chatNode);
        });
        chats.sort(function (a, b) {
          return a.timestamp - b.timestamp;
        });
        this.setState({
          chats,
          user: location.state.userObj,
        });
        // setTimeout(function () {
        //   chatArea.scrollBy(0, chatArea.scrollHeight);
        // }, 200);
        this.setState({ loadingChats: false });
      });
    } catch (error) {
      console.error(error);
      var errorObj = {
        component: 'ChatWindow',
        method: 'setChatArea',
        error: error
      }
      logError(errorObj);
      this.setState({ readError: error.message, loadingChats: false });
    }
  }

  async handleTextAreaChange(event) {
    this.setState({
      content: event.target.value,
    });
  }

  async deleteChat(params) {
    try{
      const { t } = this.props;
      swal({
        text: t("Are you sure want to delete this chat" + "?"),
        icon: "warning",
        dangerMode: true,
        buttons: [t("Cancel"), t("Ok")]
      })
        .then((willDelete) => {
          if (willDelete) {
            let myKey = params;
            let chatroom = this.setChatRoom(JSON.parse(localStorage.getItem("obj")).userId, this.props.location.state.applicant.id);
            // remove item from database
            let my_db_ref = db.ref(chatroom + '/' + myKey);
            my_db_ref.once('value', function (snapshot) {
              let myChatObj = {};
              myChatObj = snapshot.val();
              myChatObj.key = snapshot.key;
              myChatObj.archieve = true;
              console.log("myChatObj::", myChatObj);
              my_db_ref.set(myChatObj);
            });
          }
        });
    }catch(err){
      console.log(err)
      var errorObj = {
        component: 'ChatWindow',
        method: 'deleteChat',
        error: err
      }
      logError(errorObj);
    }
  }
  async switchToPeerChat(peerUserId, nickname) {

    console.log("switchToPeerChat peerUserId", peerUserId);
    var applicantObj = {
      // avtaar: null,
      // communityId: "d4904bc7a56e0dfc285d8fd19b31d062",
      // countOfMsgs: 0,
      // deviceSerialNumber: "58a5f0d3-7daa-4607-8b37-844ab295bdc7",
      // fcmId: null,
      id: peerUserId,
      isactive: true,
      nickName: nickname,
      roleId: JSON.parse(localStorage.getItem("obj")).roleId,
      roleType: JSON.parse(localStorage.getItem("obj")).roleType,
      title: peerUserId,
      userName: null,
    }
    console.log("inside openChat");
    // auth().signOut();
    // this.setState({open: true})
    // this.setState({isLoading: true})


    this.setState({ applicantObj, }, () => {

      if (auth().currentUser == null) {
        this.setState({ open: true });
      } else {
        this.setState({ isLoading: true });
        this.gotoChat(auth().currentUser);
      }
    }
    );
  }

  gotoChat(user) {
    ///layout/peerchat/chatwindow
    console.log("gotoChat>>", this.state.applicantObj);
    this.props.history.push({
      pathname: "/layout/switch-to-peer",
      state: {
        applicant: this.state.applicantObj,
        userObj: user,
        chatType: 'peer',
      },
    });
  }

  async handleSubmit(event) {
    console.log("chat handleSubmit clicked");

    if (this.state.isButtonDisabled) {
      return;
    }

    if (this.state.content) {
      this.setState({ isButtonDisabled: true });
      let { userObj, location, fbuserObj, communityuid } = { ...this.props };
      let chatType = location.state.chatType;
      let adminUnreadCount = 0;
      console.log("chatType", chatType);
      if (chatType == 'admin') {
        adminUnreadCount = 1;
      }
      console.log("adminUnreadCount", adminUnreadCount)
      event.preventDefault();
      this.setState({ writeError: null });
      const chatArea = this.myRef.current;
      try {
        let chatroom = this.setChatRoom(JSON.parse(localStorage.getItem("obj")).userId, location.state.applicant.id);
        let data = {
          content: this.state.content,
          timestamp: Date.now(),
          userid: JSON.parse(localStorage.getItem("obj")).userId,
          fbuid: location.state.userObj.uid,
          systemuid: '',
          name: location.state.userObj.displayName,
          avatarurl: location.state.userObj.photoURL,
          adminunread: adminUnreadCount
        };
        await db.ref(chatroom).push(data);
        if (chatType == 'admin') {
          let adminAlertData = {
            content: this.state.content,
            timestamp: Date.now(),
            userid: JSON.parse(localStorage.getItem("obj")).userId,
            name: location.state.userObj.displayName
          }
          let adminchatroom = `${communityuid}`;
          await db.ref(adminchatroom + '/' + chatType + '/adminalert').push(adminAlertData);
        }
        this.setState({ content: "", isButtonDisabled: false });
        chatArea.scrollBy(0, chatArea.scrollHeight);

        if (location.state.chatType == 'peer' || location.state.chatType == 'admin') {
          // set parameters and then send notification: peer to peer
          var notiParmas = {
            to: location.state.applicant.fcmId,
            title: location.state.userObj.displayName ? location.state.userObj.displayName : JSON.parse(localStorage.getItem("obj")).userId,
            message: data.content,
            page: '/layout/chatwindow',
            applicant: { id: location.state.applicant.id },
            senderObj: { id: JSON.parse(localStorage.getItem("obj")).userId, fcmId: localStorage.getItem('fcmToken') },
            chatType: 'peer'
          }
          console.log("notiParmas", notiParmas);
          Services.sendPushNotification(notiParmas);

          // increament chat counter for the msgRecieverUserId
          var counterParams = {
            communityId: this.props.communityuid,
            msgRecieverUserId: location.state.applicant.id,
            msgSenderUserId: JSON.parse(localStorage.getItem("obj")).userId,
            noOfMsgsSend: 1
          }
          console.log("counterParams", counterParams)
          Services.addChatHistoryUsingUserId(counterParams);

        } else {
          // set paramenter and then send notification in group-chat

          var notiParmas = {
            to: "/topics/" + this.state.topic,
            title: location.state.applicant.groupName,
            message: data.content,
            page: '/layout/chatwindow',
            applicant: { id: location.state.applicant.id },
            chatType: 'group'
          }

          console.log(notiParmas)
          Services.sendPushNotification(notiParmas);

          // increament group chat counter for the msgRecieverUserId
          var counterParams = {
            communityId: this.props.communityuid,
            groupId: location.state.applicant.id, //group id
            msgSenderUserId: JSON.parse(localStorage.getItem("obj")).userId,
            noOfMsgsSend: 1,
            type: "group",
            moderatorApprovedUsers: location.state.applicant.isModeratorRequired
          }
          console.log("addChatHistoryOnGroupUsingUserId counterParams", counterParams)
          Services.addChatHistoryOnGroupUsingUserId(counterParams);
        }

      } catch (error) {
        console.error(error);
        var errorObj = {
          component: 'ChatWindow',
          method: 'handleSubmit',
          error: error
        }
        logError(errorObj);
        this.setState({ writeError: error.message });
      }
    }
  }

  handleLogout() {
    this.setState(
      {
        authenticated: false,
      },
      () => {
        auth().signOut();
      }
    );
  }

  formatTime(timestamp) {
    const d = new Date(timestamp);
    const time = `${d.getDate()}/${d.getMonth() + 1
      }/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
    return time;
  }

  handleChange = (event, newValue) => {
    try{
      if(newValue){
        this.setState({
          value: newValue,
        });
      }
    }catch(err){
      console.log(err)
      var errorObj = {
        component: 'ChatWindow',
        method: 'handleChange',
        error: err
      }
      logError(errorObj);
    }
  };

  handleChangeIndex = (index) => {
    this.setState({
      value: index,
    });
  };

  handleImageAsFile(e) {
    var that = this;
    try{
      if (e.target.files[0]) {
        const image = e.target.files[0];
        console.log(image)
        const uploadTask = storageRef.ref(`/images/${image.name}`).put(image)
        //initiates the firebase side uploading 
        uploadTask.on('state_changed', (snapShot) => {
          //takes a snap shot of the process as it is happening
          console.log(snapShot)
          const progress = Math.round((snapShot.bytesTransferred / snapShot.totalBytes) * 100);
          this.setState({ progress });
        }, (err) => {
          //catches the errors
          console.log(err)
        }, () => {
          // gets the functions from storage refences the image storage in firebase by the children
          // gets the download url then sets the image from firebase as the value for the imgUrl key:
          storageRef.ref('images').child(image.name).getDownloadURL().then(fireBaseUrl => {
            console.log(fireBaseUrl)
            this.setState({ progress: 0 });
            that.handleImageUpload(fireBaseUrl)
            //setImageAsUrl(prevObject => ({...prevObject, imgUrl: fireBaseUrl}))
          })
        })
      }
    }catch(err){
      console.log(err)
      var errorObj = {
        component: 'ChatWindow',
        method: 'handleImageAsFile',
        error: err
      }
      logError(errorObj);
    }
  }

  async handleImageUpload(fireBaseUrl) {
    try {
      let { userObj, location, fbuserObj } = { ...this.props };
      this.setState({ writeError: null });
      const chatArea = this.myRef.current;
      let messageContent = '';
      let chatroom = this.setChatRoom(JSON.parse(localStorage.getItem("obj")).userId, location.state.applicant.id);
      let data = {
        content: fireBaseUrl,
        type: "image",
        timestamp: Date.now(),
        fbuid: location.state.userObj.uid,
        systemuid: '',
        name: location.state.userObj.displayName,
        avatarurl: location.state.userObj.photoURL,
      };

      console.log("chatroom>>", chatroom, data);

      await db.ref(chatroom).push(data);
      this.setState({ content: "" });
      chatArea.scrollBy(0, chatArea.scrollHeight);

      if (location.state.chatType == 'peer') {
        // set parameters and then send notification: peer to peer
        var notiParmas = {
          to: location.state.applicant.fcmId,
          title: location.state.userObj.displayName ? location.state.userObj.displayName : JSON.parse(localStorage.getItem("obj")).userId,
          message: "Sent an image",
          page: '/layout/chatwindow',
          applicant: { id: location.state.applicant.id },
          chatType: 'peer'
        }
        Services.sendPushNotification(notiParmas);

        // increament chat counter for the msgRecieverUserId
        var counterParams = {
          communityId: this.props.communityuid,
          msgRecieverUserId: location.state.applicant.id,
          msgSenderUserId: JSON.parse(localStorage.getItem("obj")).userId,
          noOfMsgsSend: 1
        }
        console.log("counterParams", counterParams)
        Services.addChatHistoryUsingUserId(counterParams);
      } else {
        // set paramenter and then send notification in group-chat
        var notiParmas = {
          to: "/topics/" + this.state.topic,
          title: location.state.userObj.displayName ? location.state.userObj.displayName : JSON.parse(localStorage.getItem("obj")).userId,
          message: "Sent an image",
          page: '/layout/chatwindow',
          applicant: { id: location.state.applicant.id },
          chatType: 'group'
        }
        Services.sendPushNotification(notiParmas);

        // increament group chat counter for the msgRecieverUserId
        var counterParams = {
          communityId: this.props.communityuid,
          groupId: location.state.applicant.id, //group id
          msgSenderUserId: JSON.parse(localStorage.getItem("obj")).userId,
          noOfMsgsSend: 1,
          type: "group",
          moderatorApprovedUsers: location.state.applicant.isModeratorRequired
        }
        console.log("addChatHistoryOnGroupUsingUserId counterParams", counterParams)
        Services.addChatHistoryOnGroupUsingUserId(counterParams);
      }

    } catch (error) {
      console.error(error);
      var errorObj = {
        component: 'ChatWindow',
        method: 'handleImageUpload',
        error: error
      }
      logError(errorObj);
      this.setState({ writeError: error.message });
    }
  }

  getDateDiff() {
    let groupedResults = _.groupBy(this.state.chats, (result) => moment(new Date(result['timestamp']), 'DD/MM/YYYY').startOf('day'));
    return groupedResults
  }


  linkify(inputText) {
    try{
      if(!inputText){
        return '';
      }else{
        var replacedText, replacePattern1, replacePattern2, replacePattern3;
    
        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    
        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    
        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
    
        return replacedText;
      }
    }catch(err){
      console.log(err)
      var errorObj = {
        component: 'ChatWindow',
        method: 'linkify',
        error: err
      }
      logError(errorObj);
    }
  }

  handleImgModalOpen(chat) {
    if (chat.type && chat.type == "image") {
      swal({
        title: "",
        text: "",
        icon: chat.content,
        showCancelButton: false,
        buttons: false
      });
    }
  }

  render() {
    try{
    const { t } = this.props;
    const { classes, theme, chatConfig, location } = this.props;
    const roleId = JSON.parse(localStorage.getItem("obj")).roleId;
    const roleType = JSON.parse(localStorage.getItem("obj")).roleType;
    const sentuserId = JSON.parse(localStorage.getItem("obj")).userId;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};

    if (location.state == undefined) {
      return <div>data not found</div>
    }

    var userUid = null;
    if(JSON.parse(localStorage.getItem("obj"))){
      userUid = JSON.parse(localStorage.getItem("obj")).userId
    }else{
      userUid = this.state.user.uid
    }
    var tabtilte = location.state.chatType == "admin" ? "admin" : (this.props.location.state.applicant.nickName != null ? this.props.location.state.applicant.nickName : this.props.location.state.applicant.title);
    var username = location.state.userObj.displayName ? location.state.userObj.displayName : sentuserId
    var imgsrc = this.props.location.state.applicant.avtaar ? this.props.location.state.applicant.avtaar : this.props.location.state.applicant.urlOfIcon

    var chats = []
    if (this.state && this.state.chats && this.state.chats.length > 0) {
      chats = this.getDateDiff()
    }
    return (
      <div className={classes.root + " ChatWindow getknowledgeable_page"}>
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <AppBar className="chatheader" position="static" style={bgStyles}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="#fff"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label={t(tabtilte)} {...a11yProps(0)} />
          </Tabs>
        </AppBar>

        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
          className="infotabcontainer getaccesstabspage forum-chat-window"
        >
          <TabPanel className="chatmsglistholdermain" value={this.state.value} index={0} dir={theme.direction}>
            {
              templateID == 1 && (
                <Grid item xs={12}>
                  <Grid container spacing={3} className="gridcontainer border-bottom-grey white_bg border-topleftradius-10px border-toprightradius-10px">
                    <Grid item xs={2} className="text-center hospitaliconholder color-darkblue">
                    {
                      imgsrc!=null?(
                      <svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                        <image href={imgsrc} width="25" height="25" />
                      </svg>):(
                        <AccountCircleIcon />
                      )
                      }

                    </Grid>
                    <Grid item xs={10} className="text-left">
                      <p className="forumtitle color-darkblue">{t(tabtilte)}</p>
                      {/* <p className="chatlastseeninfo">Last seen:23/03/21</p> */}
                    </Grid>
                  </Grid>
                </Grid>
              )
            }

            <div id="frame" className={location.state.chatType == "group" ? 'showgroupaction' : 'peeraction'}>
              <div class="content">
                <div class="messages" id="chatBox" ref={this.myRef}>
                  <ul >
                    {this.state && this.state.chats && this.state.chats.length == 0 ?
                      <div></div>
                      :
                      Object.keys(chats).map((key) => {
                        return <>
                          {
                            chats[key].map((chat) => {
                              return userUid === chat.userid ? (
                                <li className={`sent ${chat.archieve ? "hide" : ""}`}>
                                  <div className="msg-wrap">
                                    <div className="msg">
                                      <span className="msg-del-btn" onClick={() => this.deleteChat(chat.key)}>{<CancelIcon />}</span>
                                      <div onClick={(e) => this.handleImgModalOpen(chat,e)}>
                                        <svg className="MuiSvgIcon-root chatavatar" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ float: 'left' }}
                                        >
                                          <image href={chat.avatarurl} width="25" height="25" />
                                        </svg>
                                        <div className="msg-info">{username ? username : chat.userid}</div>
                                        <div className="msg-txt">
                                          {
                                            chat.type && chat.type == "image" ? (
                                              <img className="chatimag" src={chat.content} alt="image tag" />

                                            ) : (
                                              <span>{parse(this.linkify(chat.content))}</span>
                                            )
                                          }
                                        </div>
                                        <div className="chat-time">
                                          {this.formatTime(chat.timestamp, 'time')}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ) : (
                                <li className={`replies ${chat.archieve ? "hide" : ""}`}>
                                  <div className="msg-wrap">
                                    <div className="msg">
                                      {(roleType == 'Admin' || roleType == 'SuperAdmin') ? (<span className="msg-del-btn" onClick={() => this.deleteChat(chat.key)}>{<CancelIcon />}</span>) : ''}
                                      <div onClick={(e) => this.handleImgModalOpen(chat,e)}>
                                        <div className="msg-info">
                                          <div className="msgname">
                                        <svg className="MuiSvgIcon-root chatavatar" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ float: 'left' }}
                                        >
                                          <image href={chat.avatarurl} width="25" height="25" />
                                        </svg>
                                            {tabtilte == "admin" ? "admin" : (chat.name ? chat.name : chat.userid)}
                                          </div>
                                          {location.state.chatType == "group" ?
                                            <div className="reporticondiv">
                                            <span className="reporticon" onClick={(e)=> this.Reporthandleclick(chat.userid, chat.name, chat.avatarurl, chat.fcmid, chat,e)}>
                                              <ReportIcon />
                                            </span>
                                            <span className="fa fa-comments" onClick={(e) => this.switchToPeerChat(chat.userid, chat.name, chat.avatarurl, chat.fcmid,e)}></span>
                                            </div>
                                            : ''}
                                        </div>
                                        <div className="msg-txt" >
                                          {
                                            chat.type && chat.type == "image" ? (
                                              <img className="chatimag" src={chat.content} alt="image tag" />

                                            ) : (
                                              <span>{parse(this.linkify(chat.content))}</span>
                                            )
                                          }
                                        </div>
                                        <div className="chat-time">
                                          {this.formatTime(chat.timestamp, 'time')}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          }
                        </>
                      })
                    }
                  </ul>
                  {
                    this.state.progress > 0 && (
                      <div class="text-center"><progress value={this.state.progress} max="100" class="progress"></progress></div>
                    )
                  }

                </div>
              </div>
            </div>
            <div className="chatbtmmenu">
              {
                templateID == 1 ? (
                  <Grid item xs={12} className="text-center">
                    <Grid container spacing={3} className="gridcontainer border-top-grey white_bg border-bottomleftradius-10px border-bottomrightradius-10px">
                      <Grid item xs={2} className="text-center hospitaliconholder color-darkblue">
                        <Button
                          variant="contained"
                          component="label"
                          className="menubtn  chatgallerybutton"
                        >
                          <AttachmentIcon />
                          <input
                            onChange={this.handleImageAsFile}
                            type="file"
                            hidden
                          />
                        </Button>

                      </Grid>

                      <Grid item xs={8} className="text-left">
                        <p className="zero chatmsgtextboxholder">
                          <TextField
                            id="standard-basic"
                            label=""
                            placeholder={t("Type here")}
                            helperText=""
                            value={this.state.content}
                            onChange={this.handleTextAreaChange}
                            style={{ 'margin-left': '10px' }}
                          />
                        </p>
                      </Grid>

                      <Grid item xs={2} className="text-center hospitaliconholder color-darkblue">
                        <IconButton
                          edge="start"
                          className="menubtn"
                          color="inherit"
                          aria-label="menu"
                          disabled={this.state.isButtonDisabled}
                          onClick={this.handleSubmit}
                        >
                          <SendIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={0} className="gridcontainer">
                    <Grid item xs={8} className="zero">
                      <TextField
                        id="standard-helperText"
                        label=""
                        placeholder={t("Type here")}
                        helperText=""
                        value={this.state.content}
                        onChange={this.handleTextAreaChange}
                        style={{ 'margin-left': '10px' }}
                      />
                    </Grid>
                    <Grid item xs={2} className="zero text-center">
                      <Button
                        variant="contained"
                        component="label"
                        className="menubtn  chatgallerybutton"
                      >
                        <CameraAltIcon />
                        <input
                          onChange={this.handleImageAsFile}
                          type="file"
                          hidden
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={2} className="zero text-center">
                      <IconButton
                        edge="start"
                        className="menubtn"
                        color="inherit"
                        aria-label="menu"
                        disabled={this.state.isButtonDisabled}
                        onClick={this.handleSubmit}
                      >
                        <SendIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                )
              }

            </div>
          </TabPanel>

        </SwipeableViews>
      </div>
    );
  }catch(err){
    console.log("err::", err);
  } 
}
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    userObj: storeState.userDetail,
    chatConfig: storeState.chatConfig,
    fbuserObj: storeState.fbuserObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const tChatWindow = withTranslation()(ChatWindow);
const ThemeChatWindow = withTheme(tChatWindow);
const FinalThemeChatWindow = withStyles(useStyles)(ThemeChatWindow);
const routeChatWindow = withRouter(FinalThemeChatWindow);
export default connect(mapStateToProps, { setChatType })(routeChatWindow);
